import React from 'react';
import { Card, CardContent } from './ui/card';

const VenueSkeleton = () => {
  return (
    <Card className="overflow-hidden hover:shadow-xl transition-all duration-300 animate-pulse">
      <CardContent className="p-0">
        {/* Image Skeleton */}
        <div className="relative h-64 bg-gray-200" />
        
        {/* Content Skeleton */}
        <div className="p-4 space-y-3">
          {/* Title */}
          <div className="h-6 bg-gray-200 rounded w-3/4" />
          
          {/* Location */}
          <div className="h-4 bg-gray-200 rounded w-1/2" />
          
          {/* Capacity & Rating */}
          <div className="flex items-center gap-4">
            <div className="h-4 bg-gray-200 rounded w-24" />
            <div className="h-4 bg-gray-200 rounded w-20" />
          </div>
          
          {/* Price */}
          <div className="h-5 bg-gray-200 rounded w-32 mt-2" />
          
          {/* Button */}
          <div className="h-10 bg-gray-200 rounded w-full mt-4" />
        </div>
      </CardContent>
    </Card>
  );
};

// Grid of skeletons
export const VenueSkeletonGrid = ({ count = 6 }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {Array.from({ length: count }).map((_, index) => (
        <VenueSkeleton key={index} />
      ))}
    </div>
  );
};

export default VenueSkeleton;
